<app-module-header [title]="organization.organizationName + ' - ' + ('OPERATORS.TITLE' | transloco)"
icon="support_agent"></app-module-header>
@if (isLoading) {
  <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<mat-tab-group dynamicHeigh syncTabsWithUrl>
  <mat-tab [label]="'OPERATORS.INVOICES' | transloco" urlKey="page-list">
    <div class="tab-content">

      <mat-tab label="LPR Kamerastatus" urlKey="lpr-status">
        <div class="tab-content">
          @if (lprCamerasLoading) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }

          <table mat-table [dataSource]="lprCameras" class="mat-elevation-z2 w-100">

            <ng-container matColumnDef="sensorId">
              <th mat-header-cell *matHeaderCellDef>Sensor ID</th>
              <td mat-cell *matCellDef="let cam">{{ cam.sensorId }}</td>
            </ng-container>

            <ng-container matColumnDef="lastRequest">
              <th mat-header-cell *matHeaderCellDef>Senaste LPR</th>
              <td mat-cell *matCellDef="let cam" [style.color]="getCameraStatusColor(cam.minutesAgo)">
                {{ formatMinutesAgo(cam.minutesAgo) }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="lprCameraColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: lprCameraColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell no-data-cell" [attr.colspan]="lprCameraColumns.length">
                Inga LPR-kameror hittades
              </td>
            </tr>
          </table>
        </div>
      </mat-tab>

      <app-invoice-list [organization]="organization" [isLoading]="isLoading" (loadingChanged)="isLoading = $event">
      </app-invoice-list>

      <mat-tab label="Kameror" urlKey="cameras">
        <div class="tab-content">
          <app-cameras [organization]="organization" [showAllOrganizations]="true"></app-cameras>
        </div>
      </mat-tab>

      <mat-tab [label]="'OPERATORS.EXPORT' | transloco" urlKey="list">
        <div class="tab-content">
          <div class="container-fluid my-2 px-0">
            <div [formGroup]="downloadOrdersForm" class="container-fluid">

              <mat-form-field appearance="outline">
                <mat-label>Ordrar från</mat-label>
                <input matInput formControlName="ordersFrom" [matDatepicker]="ordersFrom">
                <mat-datepicker-toggle matSuffix [for]="ordersFrom"></mat-datepicker-toggle>
                <mat-datepicker #ordersFrom></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Ordrar till</mat-label>
                <input matInput formControlName="ordersTo" [matDatepicker]="ordersTo">
                <mat-datepicker-toggle matSuffix [for]="ordersTo"></mat-datepicker-toggle>
                <mat-datepicker #ordersTo></mat-datepicker>
              </mat-form-field>
              <button mat-raised-button color="primary" class="full-width-button" (click)="DownloadOrders()"
              [disabled]="isLoading ? true : null">Ladda ner Ordrar</button>
            </div>
            <br>
              <div class="container-fluid">
                <button mat-raised-button color="primary" class="full-width-button" (click)="DownloadParkings()"
                [disabled]="isLoading ? true : null">Ladda ner pågående parkeringar</button>
              </div>
              <br>

                <div class="container-fluid">
                  <button mat-raised-button color="primary" class="full-width-button" (click)="DownloadAdditionalServices()"
                  [disabled]="isLoading ? true : null">Ladda ner tilläggstjänster</button>
                </div>
                <br>

                <div class="container-fluid">
                  <button mat-raised-button color="primary" style="width: 100%;" (click)="DownloadPayments()"
                  [disabled]="isLoading || !downloadOrdersForm.value.ordersFrom ? true : null">Ladda ner betalningar</button>
                </div>
                <br>

                <div class="container-fluid">
                  <button mat-raised-button color="primary" style="width: 100%;" (click)="DownloadOrderParkings()"
                  [disabled]="isLoading || !downloadOrdersForm.value.ordersFrom ? true : null">Ladda ner orderparkeringar</button>
                </div>
                <br>

                  <div class="container-fluid">
                    https://github.com/you-dont-need/You-Dont-Need-Momentjs/blob/master/README.md<br>
                    https://philna.sh/blog/2021/02/22/display-dates-in-your-users-time-zone/
                  </div>
                  <br>

                    @if (timeData) {
                      <div class="container-fluid">
                        <table>
                          <tr>
                            <td>Server - Time</td>
                            <td>{{timeData.serverTime}}</td>
                          </tr>
                          <tr>
                            <td>Server - TimeUTC</td>
                            <td>{{timeData.serverTimeUTC}}</td>
                          </tr>
                          <tr>
                            <td>Server - ShuttlebussStartDate</td>
                            <td>{{timeData.shuttlebussStartDate}}</td>
                          </tr>
                          <tr>
                            <td>Frontend - Local</td>
                            <td>{{local}}</td>
                          </tr>
                          <tr>
                            <td>Frontend - LocalUTC</td>
                            <td>{{localUtc}}</td>
                          </tr>
                          <tr>
                            <td>Frontend - Server - TimeUTC to TimeSE</td>
                            <td>{{displayDate}}</td>
                          </tr>
                        </table>
                      </div>
                    }

                    <div class="row upload-row">
                      <div class="col-md-3">
                        <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)"
                          class="file-input-hidden">
                        <button type="button" class="btn btn-success" (click)="file.click()">Upload File</button>
                      </div>
                      <div class="col-md-4">
                        @if (progress > 0) {
                          <span class="upload">
                            {{progress}}%
                          </span>
                        }
                        @if (message) {
                          <span class="upload">
                            {{message}}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </div>
          </mat-tab>
        </mat-tab-group>